/**
 * Splits a string by hyphens while preserving UUIDs as single tokens
 * @param str - The string to split
 * @returns An array of strings with UUIDs kept intact
 */
export const splitPreservingUUIDs = (str: string): string[] => {
  const uuidRegex =
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
  const uuids: string[] = [];
  const placeholderPrefix = "__UUID_PLACEHOLDER_";

  // Replace UUIDs with placeholders
  const processed = str.replace(uuidRegex, (match) => {
    const index = uuids.length;
    uuids.push(match);
    return `${placeholderPrefix}${index}__`;
  });

  // Split by hyphen
  const parts = processed.split("-");

  // Restore UUIDs
  return parts.map((part) => {
    const match = part.match(/__UUID_PLACEHOLDER_(\d+)__/);
    if (match) {
      return uuids[parseInt(match[1], 10)];
    }
    return part;
  });
};
